import { render, staticRenderFns } from "./CitasAviso.vue?vue&type=template&id=b4d9505c"
import script from "./CitasAviso.vue?vue&type=script&lang=js"
export * from "./CitasAviso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports